import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

export const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const strTime = String(hours).padStart(2, '0') + ':' + minutes + ' ' + ampm;

    return `${day} ${month} ${year}, ${strTime}`;
};

export const fromNow = (date) => {
    if (!date) return "-";
    return dayjs(date).fromNow();
};

export const getTimeLeft = (finalEndDate) => {
    if (!finalEndDate) return "";
    const end = new Date(finalEndDate);
    const now = new Date();

    // 1. If the final technical end date has passed, the deal is truly over.
    if (now >= end) return "Expired";

    // 2. Calculate time remaining until midnight tonight.
    const midnight = new Date();
    midnight.setHours(23, 59, 59, 999);

    let diff = midnight - now;

    // 3. If the deal ends BEFORE midnight today, use the actual end time.
    if (midnight > end) {
        diff = end - now;
    }

    if (diff <= 0) return "Refreshing...";

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (hours > 0) {
        return `${hours}h ${minutes}m left`;
    } else {
        return `${minutes}m left`;
    }
};

